// extracted by mini-css-extract-plugin
export var layoutContainer = "_55-0";
export var layoutContainerNoRounding = "_55-6";
export var layoutContainerOpen = "_55-5";
export var layoutContainerResizing = "_55-1";
export var mainContent = "_55-2";
export var resizeDivider = "_55-3";
export var slidePanel = "_55-4";